module.exports = __webpack_public_path__ + "img/IEM_logo-white.c807af90.png";